/**
 * Local HTML5 video, YouTube embed, or a "coming soon" panel with written steps.
 */
import React from 'react';
import { hasPlayableVideo } from '../config/helpVideos';
import './HelpVideoEmbed.css';

const HelpVideoEmbed = ({ video, compact = false }) => {
  if (!video) return null;

  const localSrc = video.src && String(video.src).trim();
  const youtubeId = video.youtubeId && String(video.youtubeId).trim();
  const playable = hasPlayableVideo(video);

  let media = null;
  if (localSrc) {
    media = (
      <div className="help-video-embed-frame help-video-embed-frame--local">
        <video
          className="help-video-embed-video"
          src={localSrc}
          controls
          playsInline
          preload="metadata"
          title={video.title}
        >
          Sorry, your browser does not support embedded videos.
        </video>
      </div>
    );
  } else if (youtubeId) {
    media = (
      <div className="help-video-embed-frame">
        <iframe
          title={video.title}
          src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    );
  } else if (!playable) {
    media = (
      <div className="help-video-embed-placeholder" role="status">
        <p className="help-video-embed-placeholder-label">Video coming soon</p>
        <p className="help-video-embed-placeholder-hint">
          Until the recording is published, use the steps below.
        </p>
      </div>
    );
  }

  return (
    <div className={`help-video-embed${compact ? ' help-video-embed--compact' : ''}`}>
      {media}

      {video.summary && (
        <p className="help-video-embed-summary">{video.summary}</p>
      )}

      {Array.isArray(video.steps) && video.steps.length > 0 && (
        <ol className="help-video-embed-steps">
          {video.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default HelpVideoEmbed;
